namespace $ { $mol_style_attach( "mol/plot/ruler/hor/hor.view.css",
 "[mol_plot_ruler_hor_label] {\n\ttransform: translateY( -4px );\n}\n\n[mol_plot_ruler_hor_title] {\n\ttransform: translateY( -4px );\n}\n"
) }